var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$$FormData.slicer_type === 'line')?_c('div',{staticClass:"assist-slicer line",style:({
    padding: ("0 " + (_vm.$$FormData.slicer_padding) + "px"),
    backgroundColor: _vm.$$FormData.background_color,
  })},[_c('div',{staticClass:"assist-slicer__hr",style:({borderTop: ("1px " + (_vm.$$FormData.slicer_style) + " " + (_vm.$$FormData.slicer_color))})})]):_c('div',{staticClass:"assist-slicer",style:({
    height: _vm.$$FormData.blank_height + 'px',
    backgroundColor: _vm.$$FormData.background_color,
  })})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4daf0e0c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Decors/AssistSlicer/AssistSlicerPreview.vue
// module id = null
// module chunks = 